<div class="container-fluid" *ngIf="isDataAvailable">
  <fieldset class="border rounded-3 p-1">
    <legend class="float-none w-auto px-1 font-size-13">{{'REVIEW_SOL_POLICY_EXCEPTIONS_TAB.TITLE' | translate}}
    </legend>
    <div class="row">
      <div class="col-sm-9 col-md-10">
        <div class="custom-table">
          <div class="example-container">
            <table mat-table [dataSource]="dataSourceItem"
              class="custom-table full-width table table-bordered no-border">
              <div *ngFor="let column of columns">
                <ng-container *ngIf="!column.isNumber" [matColumnDef]="column.field">
                  <th mat-header-cell *matHeaderCellDef class="custom-header"> {{
                    column.header | translate }} </th>
                  <td mat-cell *matCellDef="let element" class="custom-cell"> {{
                    element[column.field] }} </td>
                </ng-container>
                <ng-container *ngIf="column.isNumber" [matColumnDef]="column.field">
                  <th mat-header-cell *matHeaderCellDef class="custom-header"> {{
                    column.header | translate }} </th>
                  <td mat-cell *matCellDef="let element" class="custom-cell"> 
                    <span *ngIf="typeof(element[column.field]) === 'number'"> {{element[column.field] | decimalPrecision}}% </span>
                    <span *ngIf="typeof(element[column.field]) !== 'number'">{{ element[column.field] }}</span>
                  </td>
                </ng-container>
              </div>
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">{{'COMMON_LABELS.NO_DATA_FOUND' |
                  translate}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
<div class="container-fluid customizeText" *ngIf="!isDataAvailable">
  {{'REVIEW_SOL_POLICY_EXCEPTIONS_TAB.POLICY_EXCEPTIONS_DATA_NOT_FOUND' | translate}}
</div>